/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import { Box } from "@shared-components/Box/Box"
import { ThemeUIStyleObject } from "theme-ui"
import { AnimatableIconProps } from "@shared-components/AnimatableIcons/types"
import Arrow from "@svg-icons/accordion-arrow.component.svg"
const ICON_WIDTH = 13
const ICON_HEIGHT = 8

const accordionIconStyles: ThemeUIStyleObject = {
  position: "relative",
  display: "inline-block",
  ml: 4,
}

const accordionSymbolStyles = (
  backgroundColor: string
): ThemeUIStyleObject => ({
  position: "relative",
  top: "-4px",
  right: 2,
  transitionTimingFunction: "cubic-bezier(.55,.055,.675,.19)",
  transitionDuration: "75ms",
  transitionProperty: "transform",
  transformOrigin: "center",
  width: `${ICON_WIDTH}px`,
  height: `${ICON_HEIGHT}px`,
  "& path": {
    fill: backgroundColor,
  },
})

const accordionSymbolStylesActive: ThemeUIStyleObject = {
  transitionTimingFunction: "cubic-bezier(.215,.61,.355,1)",
  transform: "rotate(180deg)",
}

const AccordionIcon: React.FC<AnimatableIconProps> = ({
  toggleIconState,
  color: backgroundColor,
  title,
  ...props
}) => {
  return (
    <Box
      as="span"
      sx={{
        ...accordionIconStyles,
      }}
      {...(title && { "aria-label": title })}
      {...props}
    >
      <Arrow
        sx={{
          ...accordionSymbolStyles(backgroundColor as string),
          ...(toggleIconState && { ...accordionSymbolStylesActive }),
        }}
        aria-hidden
      />
    </Box>
  )
}

AccordionIcon.defaultProps = {
  color: "darkGreen",
}

export { AccordionIcon }
